var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.renderTemplate
    ? _c("div", { staticClass: "over_layout" }, [
        _c("section", { staticClass: "edit_cv" }, [
          _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "edit_block" }, [
              _c("div", { staticClass: "cv_chang_area show" }, [
                _vm.load_page
                  ? _c(
                      "div",
                      {
                        ref: "cvCraft",
                        staticClass: "cv_craft",
                        attrs: { id: "cv_craft" }
                      },
                      [
                        _c("div", { staticClass: "wathermaker" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: this.$store.state.cv.cvTheme.class_name,
                            attrs: { id: "cv_ult_2" }
                          },
                          [
                            _c("div", { staticClass: "bg_area" }, [
                              _c(
                                "div",
                                { staticClass: "cv_them_top_cv_block" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cv_them_left_img_name_block"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cv_them_img_block" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                _vm.$store.state.cv.photo ||
                                                "/vue/images/user_img.jpg"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "cv_them_right_block" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cv_them_block" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cv_them_name" },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$store.state.cv.name ||
                                                      ""
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$store.state.cv
                                                      .surname || ""
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cv_them_profession"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$store.getters
                                                      .cvProfessions || ""
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cv_them_block cv_them_career"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cv_them_name_block"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$store.getters.cv_t(
                                                      "career_objective"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$store.getters.career_objective()
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "cv_them_all_blocks" }, [
                                _c(
                                  "div",
                                  { staticClass: "cv_them_left_block" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cv_them_block cv_them_block_conditions"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cv_them_name_block" },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$store.getters.cv_t(
                                                    "conditions"
                                                  )
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("ul", [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "cv_them_ult_Conditions1_1"
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.$store.state.cv.date
                                                      ? _vm.correctDate(
                                                          _vm.$store.state.cv
                                                            .date
                                                        )
                                                      : ""
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "cv_them_ult_Conditions1_2"
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.$store.state.cv.jobStack
                                                      .title ||
                                                      _vm.$store.getters.cv_t(
                                                        "full_stack"
                                                      )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "cv_them_ult_Conditions1_3"
                                            },
                                            [
                                              _vm.$store.state.cv.jobStack
                                                .sallery
                                                ? [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.$store.getters.cv_t(
                                                            "from"
                                                          )
                                                        ) +
                                                        "\n                            "
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                              " +
                                                          _vm._s(
                                                            _vm.XFormatPrice(
                                                              _vm.$store.state
                                                                .cv.jobStack
                                                                .sallery
                                                            )
                                                          ) +
                                                          "\n                                              "
                                                      ),
                                                      _vm.$store.state.cv
                                                        .jobStackPlus
                                                        ? _c("span", [
                                                            _vm._v("+")
                                                          ])
                                                        : _vm._e()
                                                    ]),
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.$store.state.cv
                                                            .jobStackCurrency
                                                            .symbol
                                                        ) +
                                                        "\n                          "
                                                    )
                                                  ]
                                                : [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$store.getters.cv_t(
                                                            "contractual"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                            ],
                                            2
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cv_them_block cv_them_block_contact"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cv_them_name_block" },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$store.getters.cv_t(
                                                    "cv_contact"
                                                  )
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          [
                                            _vm.$store.state.cv.phone
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "cv_them_ult_tel"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "tel:" +
                                                            (_vm.$store.state.cv
                                                              .phone || "")
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$store.state.cv
                                                              .phone || ""
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                staticClass: "cv_them_ult_mail"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "mailto:" +
                                                        (_vm.$store.state.cv
                                                          .email || "")
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.$store.state.cv
                                                            .email || ""
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.$store.state.cv.address
                                              .address &&
                                            _vm.$store.state.cv.address
                                              .address !== "ZERO_RESULTS"
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "cv_them_ult_address"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.$store.state.cv
                                                            .address.address
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.$store.state.cv.cvSocials,
                                              function(icon, index) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: "icon" + index,
                                                    staticClass:
                                                      "cv_them_ult_soc"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        class: icon.class_name,
                                                        attrs: {
                                                          href: icon.url,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [_vm._v(_vm._s(icon.url))]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cv_them_block cv_them_skills"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cv_them_name_block" },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$store.getters.cv_t(
                                                    "skills"
                                                  )
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cv_them_list" },
                                          [
                                            _c(
                                              "ul",
                                              _vm._l(
                                                _vm.$store.state.cv.cvSkills,
                                                function(skill) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: "skill" + skill.id,
                                                      class: _vm.lineBr(skill)
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "cv_them_skill_percent"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cv_them_skill"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  skill.title
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cv_them_percent"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  skill.percent
                                                                ) + "%"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "cv_them_bg_lines"
                                                        },
                                                        [
                                                          _c("div", {
                                                            staticClass:
                                                              "cv_them_bg_line_active",
                                                            style: {
                                                              width:
                                                                skill.percent +
                                                                "%"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cv_them_block cv_them_lang"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cv_them_name_block" },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$store.getters.cv_t(
                                                    "languages"
                                                  )
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cv_them_list" },
                                          [
                                            _c(
                                              "ul",
                                              _vm._l(
                                                _vm.$store.state.cv.cvLanguages,
                                                function(lang) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: "lang" + lang.id,
                                                      class: _vm.lineBr(lang)
                                                    },
                                                    [
                                                      _c("vue-circle", {
                                                        ref: "lang_" + lang.id,
                                                        refInFor: true,
                                                        attrs: {
                                                          progress:
                                                            lang.percent,
                                                          size: 60,
                                                          fill: _vm.fill,
                                                          "empty-fill":
                                                            "rgba(0, 0, 0, .1)",
                                                          "animation-start-value": 0.0,
                                                          "start-angle": 11,
                                                          "insert-mode":
                                                            "append",
                                                          thickness: 5,
                                                          "show-percent": true
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "cv_them_lang_name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(lang.name)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.$store.state.cv.hasHobby &&
                                    _vm.$store.state.cv.hobbies.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cv_them_block cv_them_block_hobby"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cv_them_name_block"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$store.getters.cv_t(
                                                      "hobby"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              _vm._l(
                                                _vm.$store.state.cv.hobbies,
                                                function(hobby, index) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: "hobby" + index,
                                                      class: _vm.lineBr(hobby)
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "cv_them_icon_hobby cv_them_icon_hobby_football",
                                                        style: _vm.bgImage(
                                                          hobby.icon
                                                        )
                                                      }),
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(hobby.title) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cv_them_block cv_them_block_info"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cv_them_name_block" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$store.getters.cv_t(
                                                    "citizen"
                                                  )
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          _vm._l(
                                            _vm.$store.state.cv.cvCitizens,
                                            function(citizen) {
                                              return _c(
                                                "li",
                                                {
                                                  key: "citizen" + citizen.id,
                                                  class: _vm.lineBr(citizen)
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(citizen.title) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "cv_them_right_block" },
                                  [
                                    _vm.$store.state.cv.hasAchievement
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cv_them_block cv_them_block_sertificate"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cv_them_name_block"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$store.getters.cv_t(
                                                        "achievement"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("p", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$store.state.cv
                                                    .achievement
                                                    ? _vm.$store.state.cv.achievement.replace(
                                                        /(?:\r\n|\r|\n)/g,
                                                        "<br />"
                                                      ) || ""
                                                    : ""
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$store.state.cv.educations.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cv_them_block cv_them_block_education"
                                          },
                                          [
                                            _vm._l(_vm.pages, function(
                                              page,
                                              index
                                            ) {
                                              return _vm._l(
                                                page.count,
                                                function(p_count, p_index) {
                                                  return page.type ===
                                                    "educations" &&
                                                    page.type_id === -1
                                                    ? _c("p", {
                                                        key:
                                                          "page" +
                                                          p_count.id +
                                                          _vm.key +
                                                          p_index,
                                                        staticClass:
                                                          "new-line-br"
                                                      })
                                                    : _vm._e()
                                                }
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cv_them_name_block"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$store.getters.cv_t(
                                                        "education"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.$store.state.cv.educations,
                                              function(education, index) {
                                                return [
                                                  _vm._l(_vm.pages, function(
                                                    page
                                                  ) {
                                                    return _vm._l(
                                                      page.count,
                                                      function(
                                                        p_count,
                                                        p_index
                                                      ) {
                                                        return page.type ===
                                                          "educations" &&
                                                          page.type_id === index
                                                          ? _c("p", {
                                                              key:
                                                                "experience" +
                                                                page.id +
                                                                _vm.key +
                                                                p_index,
                                                              staticClass:
                                                                "new-line-br"
                                                            })
                                                          : _vm._e()
                                                      }
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      key: "ex" + index,
                                                      staticClass:
                                                        "cv_them_block"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "cv_them_text_info"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cv_them_block_dates_info"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cv_them_dates"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        _vm.correctDate(
                                                                          education.start,
                                                                          {
                                                                            month: true
                                                                          }
                                                                        )
                                                                      ) +
                                                                      " -\n                                " +
                                                                      _vm._s(
                                                                        _vm.correctDate(
                                                                          education.end,
                                                                          {
                                                                            month: true
                                                                          }
                                                                        ) ||
                                                                          _vm.$store.getters.cv_t(
                                                                            "present"
                                                                          )
                                                                      ) +
                                                                      "\n                              "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    education
                                                                      .location
                                                                      .address
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    education.university
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cv_them_specialty"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    education.faculty
                                                                  ) +
                                                                  ",\n                              " +
                                                                  _vm._s(
                                                                    education
                                                                      .specialization
                                                                      .title
                                                                  ) +
                                                                  ",\n                              " +
                                                                  _vm._s(
                                                                    education
                                                                      .degree
                                                                      .title
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("p", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                education.description
                                                                  ? education.description.replace(
                                                                      /(?:\r\n|\r|\n)/g,
                                                                      "<br />"
                                                                    )
                                                                  : ""
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$store.state.cv.hasExperience &&
                                    _vm.$store.state.cv.experiences.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cv_them_block cv_them_block_work"
                                          },
                                          [
                                            _vm._l(_vm.pages, function(
                                              page,
                                              index
                                            ) {
                                              return _vm._l(
                                                page.count,
                                                function(p_count, p_index) {
                                                  return page.type ===
                                                    "experiences" &&
                                                    page.type_id === -1
                                                    ? _c("p", {
                                                        key:
                                                          "page" +
                                                          p_count.id +
                                                          _vm.key +
                                                          p_index,
                                                        staticClass:
                                                          "new-line-br"
                                                      })
                                                    : _vm._e()
                                                }
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cv_them_name_block"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$store.getters.cv_t(
                                                        "work_experience"
                                                      )
                                                    )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.$store.state.cv.experiences,
                                              function(experience, index) {
                                                return [
                                                  _vm._l(_vm.pages, function(
                                                    page
                                                  ) {
                                                    return _vm._l(
                                                      page.count,
                                                      function(
                                                        p_count,
                                                        p_index
                                                      ) {
                                                        return page.type ===
                                                          "experiences" &&
                                                          page.type_id === index
                                                          ? _c("p", {
                                                              key:
                                                                "experience" +
                                                                page.id +
                                                                _vm.key +
                                                                p_index,
                                                              staticClass:
                                                                "new-line-br"
                                                            })
                                                          : _vm._e()
                                                      }
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      key: "exp" + index,
                                                      staticClass:
                                                        "cv_them_block"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "cv_them_text_info"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cv_them_block_dates_info"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cv_them_dates"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        _vm.correctDate(
                                                                          experience.start,
                                                                          {
                                                                            month: true
                                                                          }
                                                                        )
                                                                      ) +
                                                                      " -\n                                " +
                                                                      _vm._s(
                                                                        _vm.correctDate(
                                                                          experience.end,
                                                                          {
                                                                            month: true
                                                                          }
                                                                        ) ||
                                                                          _vm.$store.getters.cv_t(
                                                                            "present"
                                                                          )
                                                                      ) +
                                                                      "\n                              "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      experience
                                                                        .location
                                                                        .address
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      experience.company
                                                                    ) +
                                                                    " "
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cv_them_specialty"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  experience
                                                                    .specialization
                                                                    .title
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("p", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                experience.description
                                                                  ? experience.description.replace(
                                                                      /(?:\r\n|\r|\n)/g,
                                                                      "<br />"
                                                                    )
                                                                  : ""
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._m(0)
                                  ]
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button_download_icon" },
                [
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.$store.commit("cvDownload", {
                            show: true,
                            cv: Number(_vm.cv)
                          })
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/vue/images/icon_download.png" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("router-link", {
                    staticClass: "edite_btn",
                    attrs: {
                      to: {
                        name: "cv-edit-" + _vm.$store.state.typeCv,
                        params: {
                          lang: _vm.$store.getters.locale,
                          cv: _vm.cv
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          return _vm.destroy(_vm.cv)
                        }
                      }
                    },
                    [_c("img", { attrs: { src: "/vue/images/delete.png" } })]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "https://cvweb.ru", target: "_blank" } }, [
        _c("img", { attrs: { src: "/vue/images/cv_logo_cv.png" } })
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4db30b61", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4db30b61","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/templates/ultra/u-2/Show.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4db30b61","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/templates/ultra/u-2/Show.vue
// module chunks = 0